import { createContext, useContext, useState, useEffect, ReactNode } from "react";
import { Loader2 } from "lucide-react";

interface GlobalLoadingContextProps {
  isLoading: boolean;
  setLoading: (value: boolean) => void;
}

let _setLoading: (v: boolean) => void = () => {};

const GlobalLoadingContext = createContext<GlobalLoadingContextProps | undefined>(undefined);

export function GlobalLoadingProvider({ children }: { children: ReactNode }) {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    _setLoading = setIsLoading;
    return () => {
      _setLoading = () => {};
    };
  }, []);

  useEffect(() => {
    document.body.style.overflow = isLoading ? "hidden" : "unset";
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isLoading]);

  return (
    <GlobalLoadingContext.Provider value={{ isLoading, setLoading: setIsLoading }}>
      {children}

      {isLoading && (
        // MUDANÇA: bg-white/60 -> bg-background/80 (Adapta a cor do vidro ao tema)
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-background/80 backdrop-blur-sm transition-all duration-300">
          {/* Container "Cápsula" */}
          {/* MUDANÇA: 
              - bg-white -> bg-card
              - border-gray-100 -> border-border
              - Ajustei gap e padding para ficar mais proporcional
          */}
          <div className="flex items-center gap-4 rounded-full border border-border bg-card px-8 py-5 shadow-2xl duration-200 animate-in fade-in zoom-in-95">
            <Loader2 className="h-6 w-6 animate-spin text-primary" />

            <div className="flex flex-col">
              {/* MUDANÇA: text-gray-800 -> text-foreground */}
              <span className="text-sm font-semibold leading-none tracking-tight text-foreground">
                Carregando
              </span>

              {/* MUDANÇA: text-gray-400 -> text-muted-foreground */}
              <span className="mt-1 text-[10px] font-medium uppercase tracking-wider text-muted-foreground">
                Aguarde um momento
              </span>
            </div>
          </div>
        </div>
      )}
    </GlobalLoadingContext.Provider>
  );
}

export function useGlobalLoading() {
  const ctx = useContext(GlobalLoadingContext);
  if (!ctx) throw new Error("useGlobalLoading must be used within GlobalLoadingProvider");
  return ctx;
}

export function setGlobalLoading(value: boolean) {
  _setLoading(value);
}
